import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import rehypeRaw from 'rehype-raw';
import Footer from '../../components/shared/Footer';

const CUBS_HOME_URL = 'https://www.cubs.com/';
const DEFAULT_PAGE_TITLE = 'Chicago Cubs';

class PublicPage extends Component {
  getPage = () => {
    const query = this.props.publicPageQuery;
    const pages = query && query.genericPageWithNews;

    return Array.isArray(pages) && pages.length > 0 ? pages[0] : null;
  };

  getFooter = () => {
    const query = this.props.publicPageQuery;
    const site = query && Array.isArray(query.globalSites) ? query.globalSites[0] : null;
    const footer = site && site.mainNavigation;

    if (!footer) return null;

    return {
      ...footer,
      footerLinks: [{ route: 'https://www.cubs.com/', text: 'Cubs.com' }],
      seasonalFooterLinks: [{ route: 'https://www.cubs.com/', text: 'Cubs.com' }],
      secondaryFooterLinks: [],
    };
  };

  render() {
    const query = this.props.publicPageQuery;

    if (!query || query.loading || query.error) {
      return <div className="u-hidden">Loading</div>;
    }

    const page = this.getPage();

    if (!page) {
      window.location.replace(CUBS_HOME_URL);
      return null;
    }

    const markdown = [
      page && page.pageDescription,
      page && page.additionalPageDescription,
    ].filter(Boolean).join('\n\n');
    const pageTitle = page && page.backgroundHeader ? page.backgroundHeader : DEFAULT_PAGE_TITLE;
    const footer = this.getFooter();

    return (
      <React.Fragment>
        <Helmet>
          <title>{pageTitle}</title>
        </Helmet>
        <main
          className="freeText"
          style={{
            backgroundColor: '#fff',
            maxWidth: 'none',
            minHeight: '100vh',
            width: '100%',
          }}
        >
          <div className="freeText__body" style={{ margin: 0, width: '100%' }}>
            <ReactMarkdown
              className="markdown-body"
              remarkPlugins={[remarkBreaks]}
              rehypePlugins={[rehypeRaw]}
            >
              {markdown}
            </ReactMarkdown>
          </div>
        </main>
        {footer ? <Footer footer={footer} /> : null}
      </React.Fragment>
    );
  }
}

export default PublicPage;
